/**
 * ResourceBoard Wrapper - Provides Context to existing ResourceBoard
 * This is a transitional component during migration Phase 1
 */
import React from 'react';
import { ResourceBoardProvider } from './context/ResourceBoardContext';
import ResourceBoard from './ResourceBoard';

/**
 * Wrapper component that provides context to ResourceBoard
 * Use this instead of importing ResourceBoard directly
 */
const ResourceBoardWrapper = () => {
  return (
    <ResourceBoardProvider>
      <ResourceBoard />
    </ResourceBoardProvider>
  );
};

export default ResourceBoardWrapper;
